import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var CurrentUser = require("lib/account/CurrentUser");

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},

	})
)

@providePopulateData({waitForLoad:true})

class SoundPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onOptionChange(which) {
		this.props.onChange({ sound_enabled: which }, "You successfully changed your sound setting.");
	}

	render() {
		return (
			<div className="newsfeedSettingContainer">
				<p>
					Students can add owl and background sounds that will play on some pages.
				</p>
				<label>
					<input type="radio" onChange={ this.onOptionChange.bind(this, true) }
						checked={ this.props.prefs.sound_enabled } />
					Enable sounds
				</label><br />
				<label>
					<input type="radio" onChange={ this.onOptionChange.bind(this, false) }
						checked={ !this.props.prefs.sound_enabled } />
					Disable sounds
				</label>
			</div>
		)
	}
}


SoundPreference.WrappedComponent.propTypes = StrictPropTypes({
	prefs: PropTypes.object,
	onChange: PropTypes.func,
	populateData: PropTypes.func
});

module.exports = SoundPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/SoundPreference.js